import { AfterViewInit, Component, Input, OnChanges } from '@angular/core';
import SwaggerUI, { SwaggerUIPlugin } from 'swagger-ui';
import { CardComponent } from '../../../card/card.component';

@Component({
  selector: 'swagger-doc',
  standalone: true,
  imports: [CardComponent],
  templateUrl: './swagger-doc.component.html',
  styleUrl: './swagger-doc.component.scss',
})
export class SwaggerDocComponent implements AfterViewInit, OnChanges {
  @Input() link: string | undefined;

  @Input() hideAuthorizeAndTryItNowButton = true;

  ngAfterViewInit() {
    this.initSwaggerUI();
  }

  ngOnChanges() {
    this.initSwaggerUI();
  }

  initSwaggerUI() {
    const HideInfoUrlPartsPlugin = () => {
      return {
        wrapComponents: {
          InfoUrl: () => () => null,
        },
      };
    };

    const DisableTryItOutPlugin = () => {
      return {
        statePlugins: {
          spec: {
            wrapSelectors: {
              allowTryItOutFor: () => () => false,
            },
          },
        },
      };
    };

    const DisableAuthorizePlugin = () => {
      return {
        wrapComponents: {
          authorizeBtn: () => () => null,
        },
      };
    };

    const plugins: SwaggerUIPlugin[] = [HideInfoUrlPartsPlugin];

    if (this.hideAuthorizeAndTryItNowButton) {
      plugins.push(DisableTryItOutPlugin);
      plugins.push(DisableAuthorizePlugin);
    }

    SwaggerUI({
      dom_id: '#swaggerDoc',
      url: this.link,
      docExpansion: 'none',
      plugins: plugins,
    });
  }
}
